// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			
	}
};

(function () {  
	BoostPFS.inject(this);  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
			 if (!suggestionElement) suggestionElement = this.$uiMenuElement;   
		if (!searchElement) searchElement = this.$element;  
		if (!searchBoxId) searchBoxId = this.id; 
	};

    InstantSearch.prototype.beforeInit = function(id) {
    jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
      if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
        var clone = jQ(this).clone();
        jQ(this).replaceWith(clone);
      }
    }); 
  }
	BoostPFS.prototype.beforeBuildSearchBox = function (id) {

		// Remove theme's instant search events
		var cloneSearchBar = jQ(id).clone();
		jQ(id).replaceWith(cloneSearchBar);      
		
		
		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
		// Close theme's search pop up
		if (isCloseSearchBox && window.$ && $.fancybox){
			$.fancybox.close(true);
		}
	};

//   /* start-boost-custom */
// /* #boost-: Customize instant search results */
// InstantSearchApi.beforeCall = function(searchTerm) {
//   Globals.instantSearchQueryParams.q = Utils.encodeURIParamValue(unescape(searchTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ').replace(/#/g, ""));
//   if (!Globals.instantSearchQueryParams.q) Globals.instantSearchQueryParams.q = searchTerm // avoid breaking the search
// }

var searchSubmit = SearchInput.prototype._onSubmit;
  
SearchInput.prototype._onSubmit = function(event, redirect) {
  searchSubmit.call(this, event, redirect);
  
  var term = unescape(Globals.currentTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ').replace(/#/g, "");

  console.log(term)
  
  var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);
  
  var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
  
  if (isApiReturnedResult) {
    if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
      Utils.setWindowLocation(redirectUrl);
    } else {
      this.isChangePage = true;
      this.$searchForm[0].submit();
    }
  } 
}
/* end-boost-custom */
  // Boost 150490
  jQ(window).on('load', function() {
   // executes when complete page is fully loaded, including all frames, objects and images
     setTimeout(function(){
        jQ('#boost-pfs-search-box-0').on('paste', function(event) { 
            setTimeout(function(){
                 jQ('#boost-pfs-search-box-0').click();
            },300)
         });
     },300)
  });
  // END Boost 150490

  InstantSearchApi.beforeCall = function(eventType, eventInfo) {
    if (Shopify && Globals) {
      Globals.instantSearchQueryParams.currency = Shopify.currency.active;
      Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
      Globals.instantSearchQueryParams.country = Shopify.country;
      Globals.instantSearchQueryParams.return_all_currency_fields = false;
    }
  }

})();